module.exports = __webpack_public_path__ + "img/Building.08fd965c.svg";